import { useState } from 'react'
import { Route } from 'react-router-dom'
import { useBottomSheet } from '../state-management/contexts/BottomSheetContext'
import { roundOffAndFormatNumberWithCurrency } from '../utils/utils'

const INITIAL_ITEMS = [
  { id: '1', label: 'Equity allocation', amount: 150000 },
  { id: '2', label: 'Debt allocation', amount: 85000 },
  { id: '3', label: 'Gold / others', amount: 25000 },
  { id: '4', label: 'Emergency fund', amount: 200000 },
  { id: '5', label: 'SIP monthly', amount: 12000 },
  { id: '6', label: 'Lump sum planned', amount: 50000 },
  { id: '7', label: 'Existing equity', amount: 320000 },
  { id: '8', label: 'Existing debt', amount: 180000 },
  { id: '9', label: 'Target corpus', amount: 5000000 },
  { id: '10', label: 'Current total', amount: 500000 },
  { id: '11', label: 'Shortfall', amount: 4500000 },
  { id: '12', label: 'Expected return %', amount: 12 },
  { id: '13', label: 'Tenure (years)', amount: 15 },
  { id: '14', label: 'Inflation %', amount: 6 },
  { id: '15', label: 'Post-tax yield', amount: 8 }
]

type SheetItem = { id: string; label: string; amount: number }

function EditableAmountsSheetContent({ onDismiss }: { onDismiss: () => void }) {
  const [items, setItems] = useState<SheetItem[]>(INITIAL_ITEMS)

  const updateAmount = (id: string, value: string) => {
    const num = value === '' ? 0 : Math.max(0, parseInt(value.replace(/\D/g, ''), 10) || 0)
    setItems((prev) => prev.map((it) => (it.id === id ? { ...it, amount: num } : it)))
  }

  const total = items.reduce((sum, it) => sum + it.amount, 0)

  return (
    <div className="p-5 pb-8">
      <div className="text-[18px] font-[600] text-[#232323] mb-4">Edit amounts</div>
      <div className="flex flex-col gap-1 max-h-[60vh] overflow-y-auto no-scrollbar">
        {items.map((item) => (
          <div
            key={item.id}
            className="flex items-center justify-between py-2 border-b border-[#F0F4F7] gap-3"
          >
            <span className="text-[14px] font-[400] text-[#6A6E6E] shrink-0">{item.label}</span>
            <input
              type="text"
              inputMode="numeric"
              value={item.amount === 0 ? '' : item.amount}
              onChange={(e) => updateAmount(item.id, e.target.value)}
              className="text-[14px] font-[500] text-[#232323] text-right border border-[#E0E5E5] bg-white rounded-lg px-3 py-2 w-[120px] min-w-0"
            />
          </div>
        ))}
      </div>
      <div className="flex items-center justify-between pt-4 mt-2 border-t border-[#EBF2F2]">
        <span className="text-[14px] font-[500] text-[#232323]">Total</span>
        <span className="text-[16px] font-[600] text-[#232323]">
          {roundOffAndFormatNumberWithCurrency(total)}
        </span>
      </div>
      <div
        onClick={onDismiss}
        className="mt-4 py-3 text-center text-[14px] font-[500] text-[#992617] cursor-pointer rounded-xl bg-[#F5EBE9]"
      >
        Done
      </div>
    </div>
  )
}

export default function EditableAmountsSheetPage() {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()

  return (
    <div className="min-h-screen bg-[#F5F7F7] p-5 flex flex-col items-center justify-center">
      <div className="text-[20px] font-[600] text-[#232323] mb-6 text-center">
        Editable amounts demo
      </div>
      <div
        onClick={() =>
          openBottomSheet(
            <EditableAmountsSheetContent onDismiss={closeBottomSheet} />,
            closeBottomSheet
          )
        }
        className="px-6 py-3 bg-[#992617] text-white text-[16px] font-[500] rounded-xl cursor-pointer"
      >
        Open bottom sheet
      </div>
    </div>
  )
}

export function editableAmountsSheetRoute() {
  return (
    <Route
      key="editable-amounts-sheet"
      path="/editable-amounts-sheet"
      element={<EditableAmountsSheetPage />}
    />
  )
}
